import { render, staticRenderFns } from "./is-copyright.vue?vue&type=template&id=b9f5a1ec&scoped=true&"
import script from "./is-copyright.vue?vue&type=script&lang=ts&"
export * from "./is-copyright.vue?vue&type=script&lang=ts&"
import style0 from "./is-copyright.vue?vue&type=style&index=0&id=b9f5a1ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f5a1ec",
  null
  
)

export default component.exports